"use client";
import {
  useCompositeGroupLabel
} from "../__chunks/7E5H65N4.js";
import "../__chunks/S6KFVXKD.js";
import "../__chunks/3X3MDQGM.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/LFJDOMBA.js";
import "../__chunks/6WEF4WY5.js";
import "../__chunks/OZVWZODE.js";
import "../__chunks/2SMRF6AD.js";

// src/menu/menu-group-label.ts
var useMenuGroupLabel = createHook((props) => {
  props = useCompositeGroupLabel(props);
  return props;
});
var MenuGroupLabel = createComponent(
  (props) => {
    const htmlProps = useMenuGroupLabel(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  MenuGroupLabel.displayName = "MenuGroupLabel";
}
export {
  MenuGroupLabel,
  useMenuGroupLabel
};
